module.exports = __webpack_public_path__ + "static/media/error.a48777e2.svg";